import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { Button, DashboardModule } from '@domain-group/suit-theme'

import { useFilters } from '@domain-group/react-hooks'
import type { UseFiltersPayload } from '@domain-group/react-hooks'

import useUser from '@hooks/useUser'
import useUsers from '@hooks/useUsers'
import type { UseUsersFilters } from '@hooks/useUsers'

import DashboardModuleFilters from '@components/DashboardModuleFilters'

import type { UserModel } from '@models/user'

import UserListItem from './UserListItem'

const buildPageFilterFields = () => {
  const style = {
    marginBottom: 16,
  }

  return [
    {
      component: 'DynamicInput',
      componentProps: {
        inputComponent: 'input',
        style,
      },
      key: 'string',
      label: 'Filter by Full Name, Email or Username',
    },
  ]
}

type EntityUsersProps = {
  filters: UseUsersFilters,
  initUser: Partial<UserModel>,
  loading?: boolean,
  maxHeight?: number,
  performHttpRequests?: boolean,
}

const EntityUsers = (props: EntityUsersProps) => {
  const {
    filters, initUser, loading: loadingProp, maxHeight = 600, performHttpRequests,
  } = props

  const filterPayload: UseFiltersPayload = useFilters()
  const { pageFilters } = filterPayload

  const {
    callbacks: { addUser },
  } = useUser(initUser)

  const usersPayload = useUsers({
    filters: { ...filters, ...pageFilters },
    performHttpRequests,
    requestOptions: { include_user_association_id: true },
  })

  const {
    callbacks: { loadMore },
    canLoadMore,
    filteredUsers,
    filteredUsersCount,
    hasFilteredUsers,
    loading: loadingUsers,
  } = usersPayload

  const loading = loadingUsers || loadingProp

  return (
    <DashboardModule
      boxProps={{ id: 'realhub-nav-users' }}
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={<DashboardModule.FilterHeader {...filterPayload} />}
      loading={loading}
      title="Users"
    >

      <DashboardModuleFilters
        filterFields={buildPageFilterFields()}
        {...filterPayload}
      />

      {/*
       // @ts-expect-error TS2322 */}
      <DashboardModule.ScrollableSection maxHeight={maxHeight}>
        {!loading && !hasFilteredUsers && (
          <DashboardModule.BlankState>
            <DashboardModule.BlankState.Title>
              No Users present
            </DashboardModule.BlankState.Title>

            <DashboardModule.BlankState.Paragraph>
              Please adjust your filters or create one below.
            </DashboardModule.BlankState.Paragraph>
          </DashboardModule.BlankState>
        )}

        {filteredUsers.map(user => <UserListItem key={user.id} user={user} />)}
      </DashboardModule.ScrollableSection>

      <DashboardModule.LoadMoreFooter
        boxProps={{ borderTop: loading ? 'none' : '1px solid' }}
        callbacks={{ loadMore }}
        canLoadMore={canLoadMore}
        entityCount={filteredUsersCount}
        // @ts-expect-error TS2322
        loading={loading}
      >
        <Button
          buttonStyle="secondaryEdit"
          icon={<FontAwesomeIcon icon={faPlus} />}
          onClick={() => addUser()}
          // @ts-expect-error TS2322
          size={['medium', 'small']}
          width={['100%', 'fit-content']}
        >
          Create User
        </Button>
      </DashboardModule.LoadMoreFooter>
    </DashboardModule>
  )
}

export default EntityUsers
